// extracted by mini-css-extract-plugin
module.exports = {"root":"IntroPanel_root__1R9II","questionTitle":"IntroPanel_questionTitle__25QOi","answerTitle":"IntroPanel_answerTitle__KjW4r","subtitle":"IntroPanel_subtitle__CBLvw"};